import { io, Socket } from 'socket.io-client';
import { store } from '../store';
import { addIncomingNotification } from '../store/notificationsSlice';
import { fetchConversation } from '../store/chatSlice';

let socket: Socket | null = null;

const getSocketUrl = (): string => {
  // Production: explicit API URL env var
  if (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_API_URL) {
    const rawUrl = import.meta.env.VITE_API_URL.replace(/\/$/, '');
    return rawUrl.replace(/\/api\/v1$/, '');
  }
  // Empty string = connect to same origin → Vite proxies /socket.io → localhost:5001
  return '';
};

export const connectSocket = (token: string) => {
  if (socket) {
    const currentAuth = socket.auth as any;
    if (currentAuth?.token !== token) {
      socket.auth = { token };
      if (socket.connected) {
        socket.disconnect();
      }
      socket.connect();
    } else if (!socket.connected) {
      socket.connect();
    }
    return;
  }

  const url = getSocketUrl();
  console.log(`🔌 [PWA Socket]: Connecting to ${url}`);

  socket = io(url, {
    auth: {
      token
    },
    transports: ['websocket', 'polling']
  });

  socket.on('connect', () => {
    console.log('🔌 [PWA Socket]: Connected successfully');
  });

  socket.on('new_notification', (data) => {
    console.log('🔌 [PWA Socket]: Live notification received:', data);
    store.dispatch(addIncomingNotification(data));
  });

  socket.on('new_support_message', () => {
    console.log('🔌 [PWA Socket]: Live support message alert, fetching thread...');
    store.dispatch(fetchConversation());
  });

  socket.on('disconnect', () => {
    console.log('🔌 [PWA Socket]: Disconnected');
  });
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
    console.log('🔌 [PWA Socket]: Socket cleaned up');
  }
};
